export function carousel(el) {
    const slides = el.querySelectorAll('.slide');
    const links = el.querySelectorAll('.links>a');
    const slidesContainer = el.querySelector('.slides');

  if (slides.length > 0) slides[0].classList.add("active");

  if (links.length > 0) links[0].classList.add("active");

    const updateSlides = function () {

        const countSlides = slides.length;

        for (let i = 0; i < countSlides; i++) { 
            let next = (i + 1) < countSlides ? i + 1 : 0;

            if (slides[i].classList.contains('active')) {

                slides[i].classList.remove('active');
                links[i].classList.remove('active');

                slides[next].classList.add('active');
                links[next].classList.add('active');

                if (next > 0) {
                    slidesContainer.scrollBy({
                        top: 0,
                        left: slides[i].clientWidth,
                        behavior: 'smooth'
                    });
                } else {
                    slidesContainer.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }

                break;
            }
        }
    }

    links.forEach(link => {
        link.addEventListener("click", e => {
            e.preventDefault();

            slides.forEach(el => el.classList.remove('active'));
            links.forEach(el => el.classList.remove('active'));

            e.target.classList.add('active');

            let targetId = e.target.getAttribute('href').substring(1);

            let slide = [...slides].filter(el => el.id === targetId)[0];

            slide.classList.add('active');

            slide.scrollIntoView();

            clearInterval(slideTimer);
            slideTimer = setInterval(updateSlides, 4000);

            return false;
        }, true);
    });

    let slideTimer = setInterval(updateSlides, 4000);
}

export function ImageCarousel(el) {
    const images = el.querySelectorAll('.image-carousel-image-container');

    const imagesContainer = document.createElement('div');
    imagesContainer.classList.add('images');
    
    const dots = document.createElement('div');
    dots.classList.add('dots');
    for (let i = 0; i < images.length; i++) {
        var dot = document.createElement('span');
        dot.classList.add('dot');
        dots.appendChild(dot);

        imagesContainer.appendChild(images[i]);
    }

    el.appendChild(imagesContainer);
    el.appendChild(dots);

    let img = 0;

    const scrollImage = function (index) {
        imagesContainer.scrollTo({ left: images[index].offsetLeft, behavior: 'smooth', block: 'nearest', inline: 'center' });
        for (let i = 0; i < images.length; i++) {
            dots.children[i].classList.remove('active');
            images[i].classList.remove('active');
        }
        dots.children[index].classList.add('active');
        images[index].classList.add('active');
    }

    scrollImage(img);

    setInterval(() => {
        img = img < (images.length -1) ? img + 1 : 0;
        scrollImage(img);
    }, 3000);

    dots.addEventListener('click', e => {
        let currentDot = e.target;
        img = [...dots.children].indexOf(currentDot);
        scrollImage(img);
        //images[img].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });

    return;
}

export function ImageGallery(el) {
    const images = el.querySelectorAll('img');

    const imagesContainer = document.createElement('div');
    imagesContainer.classList.add('images');

    el.appendChild(imagesContainer);

    let img = 0;

    const scrollImage = function (index) {
        imagesContainer.scrollTo({ left: images[index].offsetLeft, behavior: 'smooth', block: 'nearest', inline: 'center' });
        for (let i = 0; i < images.length; i++) {
            images[i].classList.remove('active');
        }
        images[index].classList.add('active');
    }

    scrollImage(img);

}